// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function (searchElement, fromIndex) {

			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			// 1. Let O be ? ToObject(this value).
			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
				return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			var n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			function sameValueZero(x, y) {
				return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
			}

			// 7. Repeat, while k < len
			while (k < len) {
				// a. Let elementK be the result of ? Get(O, ! ToString(k)).
				// b. If SameValueZero(searchElement, elementK) is true, return true.
				if (sameValueZero(o[k], searchElement)) {
					return true;
				}
				// c. Increase k by 1.
				k++;
			}

			// 8. Return false
			return false;
		}
	});
}

/*! https://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function () {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function () {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch (error) { }
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function (search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
	String.prototype.includes = function (search, start) {
		'use strict';
		if (typeof start !== 'number') {
			start = 0;
		}

		if (start + search.length > this.length) {
			return false;
		} else {
			return this.indexOf(search, start) !== -1;
		}
	};
}


if (!String.prototype.allMatches) {
	String.prototype.allMatches = function(regEx, notFirstStart) {
		'use strict';
		/*if (typeof index == 'undefined' || !index) { index = 0; }*/
		var ret = [],
			match = this.match(regEx),
			match2,
			i;
		if (match) {
			ret.push(match);
			//match2 = arguments.callee.call(this.substr(match.index + 1), regEx, true);
			match2 = String.prototype.allMatches.call(this.substr(match.index + 1), regEx, true);
			if (match2) {
				ret.push.apply(ret, match2);
			}
		} else {
			return null;
		}
		if (!notFirstStart) {
			/*console.dir(ret);*/
			for (i = 1; i < ret.length; i++) {
				ret[i].index += ret[i - 1].index + 1;
			}
			/*console.dir(ret);*/
		}
		return ret;
	};
}

https://github.com/javan/form-request-submit-polyfill
(function(prototype) {
	if (typeof prototype.requestSubmit == "function") return

	prototype.requestSubmit = function(submitter) {
		if (submitter) {
			validateSubmitter(submitter, this)
			submitter.click()
		} else {
			submitter = document.createElement("input")
			submitter.type = "submit"
			submitter.hidden = true
			this.appendChild(submitter)
			submitter.click()
			this.removeChild(submitter)
		}
	}

	function validateSubmitter(submitter, form) {
		submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'")
		submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button")
		submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError")
	}

	function raise(errorConstructor, message, name) {
		throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name)
	}
})(HTMLFormElement.prototype);
